// FAZ-54 — Başvuru listesindeki "kimler okudu" ikonu ("Ek Bilgi" hücresinde).
//
// Sözleşme:
//   • İzin YOKSA hiçbir şey çizilmez — backend zaten `reads: null` döndürür,
//     sayı bile tel üzerinden geçmez (kullanıcı kararı).
//   • Okuyan yoksa soluk ikon; baloncukta "Henüz okuyan yok".
//   • Okuyan varsa ikon + sayı rozeti; baloncukta kişi · rol — tarih.
//   • Gösterilen sayı, kullanıcının GÖREBİLDİĞİ kayıt sayısıdır (rütbe + birim
//     süzgeci uygulanmış hâli) — "5 okudu ama 2 isim görüyorum" olmaz.

import React from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

import HoverPopover from "../utils/HoverPopover";
import TrDateTime from "../utils/TrDateTime";

import "./ReadsCell.css";

export default function ReadsCell({ reads }) {
  if (!reads) return null;

  const sayi = Number(reads.count) || 0;
  const okuyanlar = Array.isArray(reads.readers) ? reads.readers : [];
  const kalan = Math.max(0, sayi - okuyanlar.length);

  const bos = sayi === 0;
  const Icon = bos ? EyeSlashIcon : EyeIcon;
  const label = bos
    ? "Okuyan yok"
    : `${sayi} kişi okudu — okuyanları göster`;

  // Rozet ikonun köşesine oturur (yan yana ayrı bir pul gibi durmasın).
  // İki haneden fazlası rozeti şişirip satırı bozduğu için "9+" ile kısalır;
  // gerçek sayı erişilebilir etikette ve baloncukta zaten var.
  const rozet = sayi > 9 ? "9+" : String(sayi);

  const trigger = (
    <span className="reads-trigger">
      <Icon
        className={`reads-icon ${bos ? "reads-icon--empty" : "reads-icon--active"}`}
        aria-hidden="true"
      />
      {!bos && (
        <span className="reads-badge" aria-hidden="true">
          {rozet}
        </span>
      )}
    </span>
  );

  const content = bos ? (
    <span className="reads-popover">
      <span className="reads-popover-title">Okundu bilgisi</span>
      <span className="popover-divider" aria-hidden="true" />
      <span className="reads-empty">Henüz okuyan yok</span>
    </span>
  ) : (
    <span className="reads-popover">
      <span className="reads-popover-title">Başvuru detayını açanlar</span>
      <span className="popover-divider" aria-hidden="true" />
      {okuyanlar.map((r, i) => (
        <span className="reads-row" key={r.user_id ?? `r${i}`}>
          {/* Kullanıcı kararı: ROL yazılmaz — ad ve tarih yeterli. */}
          <span className="reads-who">
            {(r.full_name || "").trim() || "Bilinmiyor"}
          </span>
          <span className="reads-when">
            <TrDateTime value={r.last_read_at} />
          </span>
        </span>
      ))}
      {reads.truncated && kalan > 0 && (
        <span className="reads-more">…ve {kalan} kişi daha</span>
      )}
    </span>
  );

  return (
    <span className="reads-cell">
      <HoverPopover trigger={trigger} label={label} content={content} />
    </span>
  );
}
